import React from 'react';
import { Col, Row } from 'react-bootstrap';

export default function BalanceInputTitle({ variable }) {
  return (
    <>
      {!variable ? (
        <Row>
          <Col md={6} className="sample-row">
            <strong>CONCEPTO</strong>
          </Col>
          <Col className="col-1 sample-row" />
          <Col md={4} className="sample-row">
            <strong>MONTO</strong>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col md={4} className="sample-row">
            <strong>CONCEPTO</strong>
          </Col>
          <Col className="col-1 sample-row" />
          <Col md={2} className="sample-row">
            <strong>ANTEPENÚLTIMO MES</strong>
          </Col>
          <Col md={2} className="sample-row">
            <strong>PENÚLTIMO MES</strong>
          </Col>
          <Col md={2} className="sample-row">
            <strong>ÚLTIMO MES</strong>
          </Col>
        </Row>
      )}
    </>
  );
}
